module.exports = "/_next/static/images/money-monotone-1adf4b6ede26224ca5ddde7a4ad491a4.svg";